var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page-wrapper"},[_c('the-navbar'),_vm._t("default"),_c('the-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }